import { styled } from 'styled-components';

const DetailsStyle = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  max-width: 100%;
  width: 100%;
  gap: 12px;
  padding: 0;

  @media (min-width: 769px) {
    flex-direction: row;
    width: 100%;
    max-width: 100%;
    justify-content: center;
  }
`;

const DetailField = styled.div`
  display: flex;
  width: 100%;
  height: 100%;
  min-width: 120px;
  min-height: 68px;
  padding: 12px;
  justify-content: space-between;
  align-items: center;
  border-radius: 8px;
  background: #27262b;
  box-sizing: border-box;

  @media (min-width: 769px) {
    padding: 12px 24px 12px 24px;
    flex-grow: 1;
    gap: 24px;
  }
`;

const DetailFieldLeft = styled(DetailField)`
  @media (min-width: 769px) {
    width: 440px;
    flex-shrink: 1;
  }
`;

const DetailFieldRight = styled(DetailField)`
  @media (min-width: 769px) {
    width: 680px;
    flex-shrink: 1;
  }
`;

const DetailLabel = styled.div`
  color: #fff;
  text-align: left;
  font-family: Rubik;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 140%; /* 19.6px */

  @media (min-width: 769px) {
    font-size: 20px;
    flex-grow: 1;
  }
`;

const DetailValue = styled.div`
  color: #fff;
  text-align: center;
  font-family: Rubik;
  font-size: 18px;
  font-style: normal;
  font-weight: 700;
  line-height: 140%; /* 19.6px */

  @media (min-width: 769px) {
    font-size: 32px;
  }
`;

export {
  DetailFieldLeft,
  DetailFieldRight,
  DetailLabel,
  DetailValue,
  DetailsStyle,
};